"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMVMapToArray = exports.CMVArrayToMap = exports.getPassLevel = exports.sortDateRange = void 0;
const core_1 = require("../../core");
const x = {
    index: [],
    protectedKeys: ['timestamp', 'index', 'systemProperties', 'protectedKeys', 'statistics'],
    timestamp: [],
    autoTrim: false,
    y: [null],
};
const sortDateRange = (drA, drB) => (drA < drB ? -1 : 1);
exports.sortDateRange = sortDateRange;
const getPassLevel = (stats, maxMin, key, stdDevs = 1) => {
    let level = maxMin === core_1.MaxMin.MAX ? Infinity : 0;
    if (stats[key]) {
        const delta = stats[key].sdPop;
        level = stats[key].mean + stdDevs * (maxMin === core_1.MaxMin.MAX ? delta : -delta);
    }
    return level;
};
exports.getPassLevel = getPassLevel;
const CMVArrayToMap = (cmvA) => {
    const keys = ['cn', 'mean', 'sqDiffFromMean', 'max', 'min'];
    const hydrated = Object.fromEntries(keys.map((k, i) => [k, cmvA[i]]));
    // Treat count of 1 and array of four nulls as 0's (I think zipping the accumulator might turn a string of four zeroes into all nulls)
    if (hydrated.cn === 1 && hydrated.mean === null) {
        hydrated.mean = 0;
        hydrated.max = 0;
        hydrated.min = 0;
        hydrated.sqDiffFromMean = 0;
    }
    return hydrated;
};
exports.CMVArrayToMap = CMVArrayToMap;
const CMVMapToArray = (cmvMap) => {
    const keys = ['cn', 'mean', 'sqDiffFromMean', 'max', 'min'];
    const cmvArr = (() => new Array(keys.length))().fill(null);
    keys.forEach((k, i) => {
        cmvArr[i] = cmvMap[k] ?? null;
    });
    return cmvArr;
};
exports.CMVMapToArray = CMVMapToArray;
